import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=1654cac8&scoped=true&"
import script from "./sitemap.vue?vue&type=script&lang=js&"
export * from "./sitemap.vue?vue&type=script&lang=js&"
import style0 from "./sitemap.vue?vue&type=style&index=0&id=1654cac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654cac8",
  null
  
)

export default component.exports